import { Component, Input, OnInit } from '@angular/core';
import { CarVehicleStorage } from 'src/app/pages/campas/campas.component';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';
import { VehicleStorage } from 'src/app/pages/new-service/interfaces/VehicleStorage';

@Component({
    selector: 'app-vehicle-storage-info',
    templateUrl: './vehicle-storage-info.component.html',
    styleUrls: ['./vehicle-storage-info.component.scss'],
})
export class VehicleStorageInfoComponent implements OnInit {

    @Input() summaryData: SummaryData = {} as SummaryData;
    @Input() vehicleStorageOrigin: CarVehicleStorage | undefined = undefined;
    @Input() vehicleStorageDestination: VehicleStorage | undefined = undefined;
    ngOnInit(): void {
    }

}